export default __webpack_public_path__ + "static/media/uz.93b0b48f.svg";